import React, { useEffect, useState } from "react";
import { NightguardForm, NightGuardProps } from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputNew";
import SelectInput from "../formComp/SelectInputNew";

const NightGuard: React.FC<NightGuardProps> = ({ onChange }) => {
  const [form, setForm] = useState<NightguardForm>({
    neededFor: "",
    margin: "",
    occlusalSurface: "",
    thickness: "",
  });

  const handleChange = (field: keyof NightguardForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-[var(--cu-text)]">
      <div className="mb-3 border-b border-[var(--cu-border)] pb-2">
        <h2 className="text-sm font-medium text-[var(--cu-accent)]">
          Nightguard / Bite Splint
        </h2>
      </div>

      <div className="w-full space-y-3">
        <SelectInput
          label="Design needed for:"
          name="neededFor"
          value={form.neededFor}
          onChange={(e) => handleChange("neededFor", e.target.value)}
          options={[
            { value: "Simple nightguard - full coverage", label: "Simple nightguard - full coverage" },
            { value: "Michigan splint", label: "Michigan splint" },
            { value: "Bleaching tray", label: "Bleaching tray" },
            { value: "Other - please specify", label: "Other - please specify" },
          ]}
        />

        <TextInput
        para="Amount of tooth and gingiva to be covered"
          label="Margin of splint"
          name="margin"
          value={form.margin}
          onChange={(e) =>
            handleChange("margin", e.target.value)
          }
        />

        <SelectInput
        optional
          label="Occlusal surface of splint"
          name="occlusalSurface"
          value={form.occlusalSurface}
          onChange={(e) => handleChange("occlusalSurface", e.target.value)}
          options={[
            { value: "Flat", label: "Flat" },
            { value: "Follow occlusal anatomy", label: "Follow occlusal anatomy" },
          ]}
        />

        <TextInput
          label="Desired thickness of splint"
          name="thickness"
          value={form.thickness}
          onChange={(e) => handleChange("thickness", e.target.value)}
        />
      </div>
    </div>
  );
};

export default NightGuard;
